import React from 'react';
import {
  AboutIntroBlockWrapper,
  AboutIntroBlockRow,
  AboutIntroBlockTitle,
  AboutIntroDescriptionWrapper,
  AboutIntroDescription,
} from '../styles/AboutIntroBlock.styled';

export default function AboutIntroBlock({ data, id, className, dir }) {
  const { column1Text, column2Text, title } = data;
  return (
    <AboutIntroBlockWrapper id={id} className={className}>
      <AboutIntroBlockRow className="smoothed">
        <AboutIntroBlockTitle dir={dir}>{title}</AboutIntroBlockTitle>
        <AboutIntroDescriptionWrapper>
          <AboutIntroDescription>{column1Text}</AboutIntroDescription>
          <AboutIntroDescription>{column2Text}</AboutIntroDescription>
        </AboutIntroDescriptionWrapper>
      </AboutIntroBlockRow>
    </AboutIntroBlockWrapper>
  );
}
